module.exports = __webpack_public_path__ + "img/47.79ab1f13.png";